import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  BackofficeReadingRoomSubmissionCard,
  ReadingRoomSubmissionRequestedDocumentItem,
  UpdateRequestedDocumentBackofficeNotesRequest
} from 'types/service.interface';
import { BaseFormComponent } from 'components/form/base-form';
import { AbstractControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MAX_LENGTH_NOTES } from 'util/form.utility';

@Component({
  selector: 'app-summary-document-row',
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, NgClass],
  templateUrl: './summary-document-row.component.html',
  styleUrl: './summary-document-row.component.scss'
})
export class SummaryDocumentRowComponent extends BaseFormComponent {
  public readonly maxFieldLength = MAX_LENGTH_NOTES;
  @Input() document!: ReadingRoomSubmissionRequestedDocumentItem;
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Input() isModal: boolean = false;
  @Output() documentNotesUpdated = new EventEmitter<BackofficeReadingRoomSubmissionCard>();

  get backofficeNotes(): AbstractControl<any, any> | null {
    return this.form.get('backofficeNotes');
  }

  override fillForm() {
    this.form = this.formBuilder.group({
      backofficeNotes: [this.document.backofficeNotes || '', [Validators.maxLength(MAX_LENGTH_NOTES)]]
    });
  }

  updateNotes() {
    this.isEditMode = false;
    this.submitAttempted = true;

    if (this.form.valid) {
      const args: UpdateRequestedDocumentBackofficeNotesRequest = {
        readingRoomSubmissionId: this.application.id,
        requestedDocumentId: this.document.id,
        backofficeNotes: this.backofficeNotes?.value || ''
      };

      this.apiService.updateVisitRoomDocumentBackofficeNotes(args).subscribe({
        next: (response: BackofficeReadingRoomSubmissionCard) => {
          this.documentNotesUpdated.emit(response);
          this.toastService.showSuccess('documentNotesUpdated', '', { shouldTranslate: true });
        },
        error: () => {
          this.toastService.showRequestError();
        }
      });
    }
  }
}
